export function isFrontendResourceError(value: unknown): boolean {
  const text = value instanceof Error ? `${value.name} ${value.message}`
    : typeof value === 'string' ? value : '';
  return /ChunkLoadError|Loading (?:CSS )?chunk \S+ failed|Failed to fetch dynamically imported module|Importing a module script failed|error loading dynamically imported module/i.test(text);
}

/** 同一轮资源加载失败只提示一次，等待用户手动刷新，不打断未保存的表单。 */
export function frontendVersionUpdateHandler(show: (onClose: () => void) => void) {
  let visible = false;
  return (event: ErrorEvent | PromiseRejectionEvent) => {
    const reason = 'reason' in event ? event.reason : event.error || event.message;
    if (!isFrontendResourceError(reason)) return;
    event.preventDefault();
    if (visible) return;
    visible = true;
    show(() => { visible = false; });
  };
}
